















































































































































import { Component, Mixins } from 'vue-property-decorator';
import { VueEditor } from 'vue2-editor';
import draggable from 'vuedraggable';
import { mapState } from 'vuex';
import _ from 'lodash';
import QuestionConditionExpressionSelect from './QuestionConditionExpressionSelect.vue';
import QuestionConditionList from './QuestionConditionList.vue';
import EditorMixins from '@/mixins/EditorMixins';
import OPERATORS from '@/constants/operators';
import { STATUSES } from '@/constants/question_group';

@Component({
  components: {
    draggable,
    QuestionConditionExpressionSelect,
    QuestionConditionList,
    VueEditor,
  },
  computed: {
    ...mapState('QuestionNegativeRule', {
      questionNegativeRule: 'questionNegativeRule',
    }),
    ...mapState('QuestionGroup', {
      questionGroup: 'questionGroup',
    }),
    ...mapState('Question', {
      question: 'question',
    }),
  },
})
export default class QuestionNegativeRuleFormFields extends Mixins(
  EditorMixins
) {
  questionNegativeRule!: Model;
  question!: Model;
  questionGroup!: Model;

  localQuestionNegativeRule: Model = {
    condition_equation: '',
    replacement_text_key: '',
    flag: '',
    comment: '',
    has_body_parts_source: false,
    conditions: [
      {
        source_type: 'question',
        source_key: '',
        matching_operator: '',
        matching_value: '',
      },
    ],
    body_parts_source: null,
  };

  isLoading = false;
  isAdvanceConditionExpressionEditor = false;
  conditionExpressionEditorErrors: string[] = [];
  operators = OPERATORS;
  statuses = STATUSES;

  questionSourceType = [
    {
      label: 'Question',
      value: 'question',
    },
  ];

  loopMethods = [
    {
      label: 'None',
      value: 'none',
    },
    {
      label: 'Loop by the options',
      value: 'loop_answer_options',
    },
    {
      label: 'Loop by the options(Number)',
      value: 'loop_times',
    },
  ];

  flags = [
    {
      label: 'Green warning',
      value: '1',
    },
    {
      label: 'Yellow warning - may be required',
      value: '2',
    },
    {
      label: 'Yellow warning - it is recommended',
      value: '3',
    },
    {
      label: 'Yellow warning - highly recommended',
      value: '4',
    },
    {
      label: 'Red warning',
      value: '5',
    },
  ];

  get bodyPartsSource() {
    return this.localQuestionNegativeRule.body_parts_source;
  }
  set bodyPartsSource(v) {
    this.localQuestionNegativeRule.body_parts_source = v;
  }

  get questions() {
    if (!this.questionGroup.library) {
      return null;
    }
    return this.questionGroup.library;
  }

  get bodyPartQuestions() {
    return this.questions.filter(
      (item: BridgeModel) => item.bridge.form_type === 'body_parts'
    );
  }

  get impactedTargetsCount() {
    return this.localQuestionNegativeRule.impacted_targets.length || 1;
  }

  beforeMount() {
    this.localQuestionNegativeRule = _.cloneDeep(this.questionNegativeRule);
    if (this.localQuestionNegativeRule.body_parts_source) {
      this.localQuestionNegativeRule.body_parts_source = this.localQuestionNegativeRule.body_parts_source.object_id;
    }
  }

  beforeDestroy() {
    this.$store.commit('QuestionNegativeRule/CLEAR_STATE');
  }

  handleSave() {
    this.save().finally(() => {
      this.isLoading = false;
    });
  }

  handleSaveClose() {
    this.save()
      .then(() => {
        this.$emit('close');
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  save() {
    this.isLoading = true;
    let action = 'QuestionNegativeRule/create';
    let payload: any = {
      ...this.localQuestionNegativeRule,
      question_oid: this.question.object_id,
    };
    if (this.localQuestionNegativeRule.object_id) {
      action = 'QuestionNegativeRule/update';
      payload = {
        objectId: this.localQuestionNegativeRule.object_id,
        config: {
          ...this.localQuestionNegativeRule,
          question_oid: this.question.object_id,
        },
      };
    }

    return this.$store
      .dispatch(action, payload)
      .then((response) => {
        this.localQuestionNegativeRule = _.cloneDeep(response.data.data);
        if (this.localQuestionNegativeRule.body_parts_source) {
          this.localQuestionNegativeRule.body_parts_source = this.localQuestionNegativeRule.body_parts_source.object_id;
        }
      })
      .finally(() => {
        this.$emit('updated');
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'success',
          message: 'The question negative rule is saved successfully.',
        });
      });
  }

  switchConditionExpressionEditor() {
    if (!this.validateConditionExpression()) {
      return;
    }

    return (this.isAdvanceConditionExpressionEditor = !this
      .isAdvanceConditionExpressionEditor);
  }

  validateConditionExpression() {
    // Always valid when the condition equation is empty
    if (this.localQuestionNegativeRule.condition_equation.length === 0) {
      this.conditionExpressionEditorErrors = [];
      return true;
    }

    // Get the array by splitting the condition equation string
    const conditionEquationArray = this.localQuestionNegativeRule.condition_equation.split(
      ' '
    );

    // Check each item in the array
    const isValid = conditionEquationArray.every((item) => {
      // Always true if the item is one of followings
      if (this.operators.includes(item) || !isNaN(item)) {
        return true;
      }

      // Match the item
      return item.match(/qnrc_[a-zA-Z0-9]+/) || false;
    });

    // Set or clear the error messages
    if (!isValid) {
      this.conditionExpressionEditorErrors = ['Invalid condition expresssion'];
    } else {
      this.conditionExpressionEditorErrors = [];
    }

    return isValid;
  }

  customFilter(item, queryText) {
    return (
      item.bridge.body.includes(queryText) ||
      (item.bridge.internal_annotation &&
        item.bridge.internal_annotation.includes(queryText))
    );
  }

  getQuestionItemText(item) {
    return this.$options.filters?.escapeHtml(item.bridge.body);
  }
}
